
export default {
  data: {
    data: {
      basicInfoSchema: {
        infoVehiculo: {
          _name: 'Información del vehículo',
          industrial_code: {
            name: 'Código industrial',
            required: false,
            type: 'text',
          },
          subversion: {
            name: 'Subversión',
            required: true,
            type: 'string',
            disabled: true
          },
          SEGMENTO: {
            name: 'Segmento',
            required: true,
            type: 'AsyncSelect',
            endpoint: '/datamasters/segments',
          },
          origen: {
            name: 'País de Origen',
            type: 'AsyncSelectCountries',
            required: false,
          },
          published: {
            name: 'Publicar en catálogo',
            required: true,
            type: 'trueBoolean',
            default: true,
            alertTooltip: 'Si tenés publicaciones activas en Canales de venta finalizarán y no podrás crear nuevas.',
            showAlertTooltip: 'false'
          },
          venta_convencional: {
            name: 'Venta Convencional',
            required: true,
            type: 'trueBoolean',
            default: true,
          },
          venta_directa: {
            name: 'Venta Directa',
            required: true,
            type: 'trueBoolean',
            default: true,
          },
          factory_price: {
            name: 'Precio de fábrica en moneda local',
            required: false,
            type: 'number',
            prefix: '$  ', // default
            decimalSeparator: false,
            limit: 10,
            thousandSeparator: '.'
          },
        },
        Monetizacion: {
          _name: 'Monetización',
          exchange_rate_id: {
            name: 'Moneda de carga',
            required: true,
            type: 'AsyncSelectObj',
            endpoint: "/abms/exchange-rates"
          },
          precio_lista: {
            name: 'Precio de lista',
            required: false,
            type: 'number',
          },
          flete_alistaje: {
            name: 'Flete y alistaje',
            required: true,
            type: 'number',
          },
          bonificacion: {
            name: 'Bonificaciones de fábrica',
            required: true,
            type: 'number',
          },
        },
        colors: {
          _name: 'Colores disponibles de fábrica',
          colors: {
            name: 'colores',
            required: false,
            type: 'colors',
          },
        },
        multimedia: {
          _name: 'Multimedia y descripción',
          description: {
            name: 'Descripción',
            required: false,
            type: 'textarea',
            limit: 500
          },
        },
      },
    },
  },
}
